import React, { useState, useEffect } from 'react';
import { HeaderTitle, Operation, Thumbnails, FormList, ExportData } from '@/components';
import { st_shop, st_user } from '@/utils/statetype';
import { useHistory } from 'react-router-dom';
import { relationUserList } from '@/api';
import { calcPrice } from '@/utils/utils';
import { useTable } from '@/hooks';
import { Table } from 'antd';

const { levelObj } = st_user;
const { levelObj: levelObjs } = st_shop;
function FinanceProfit() {
  const history = useHistory();
  const [query, setQuery] = useState({});

  const columns = {
    id: '编号',
    nickname: '用户名称',
    phone: '联系方式',
    avatarUrl: {
      title: '用户头像',
      render: e => <Thumbnails images={[e]} center />,
    },
    level: {
      title: '用户身份',
      render: e => levelObj[e],
    },
    NOINDEX_id: {
      title: '店铺编号',
      render: e => {
        const Merchant = e.Merchant || {};
        return Merchant.id || '-';
      },
    },
    NOINDEX_name: {
      title: '店铺名称',
      render: e => {
        const Merchant = e.Merchant || {};
        return Merchant.title || '-';
      },
    },
    NOINDEX_logo: {
      title: '店铺LOGO',
      render: e => {
        const Merchant = e.Merchant || {};
        return <Thumbnails images={[Merchant.shopIcon]} center />;
      },
    },
    NOINDEX_level: {
      title: '店铺身份',
      render: e => {
        const Merchant = e.Merchant || {};
        return levelObjs[Merchant.shopLevel] || '-';
      },
    },
    totalIncome: {
      title: '总收益',
      render: e => calcPrice(e),
    },
    totalAmount: {
      title: '账户余额',
      render: e => calcPrice(e),
    },
    // frozenAmount: {
    //   title: '冻结金额',
    //   render: e => calcPrice(e),
    // },
    totalSubscriptionAmount: {
      title: '总认购额',
      render: e => calcPrice(e),
    },
    totalRelationUserAmount: {
      title: '竞拍差价统计',
      render: e => calcPrice(e),
    },
    NOINDEX_operation: {
      title: '操作',
      fixed: 'right',
      render: e => (
        <Operation
          listData={{
            record: () => history.push(`/finance/profit/detail?i=${e.id}`),
            member: () => history.push(`/finance/profit/member?i=${e.id}`),
          }}
        />
      ),
    },
  };

  const changeQuery = (value = {}) => {
    // const { createdAt, status = [p_s], type = [20, 25, 30, 40, 45], premiumPriceMin, premiumPriceMax, ...props } = value;
    // const [start, end] = createdAt || [];
    // const q = {
    //   ...props,
    //   status: status.join(','),
    //   type: type.join(','),
    //   premiumPriceMin: premiumPriceMin ? premiumPriceMin * 100 : "",
    //   premiumPriceMax: premiumPriceMax ? premiumPriceMax * 100 : "",
    //   ...(createdAt && {
    //     startTime: toDateTime(start),
    //     endTime: toDateTime(end),
    //   }),
    // };
    setQuery(value);
    flagFn(true);
  };
  const { tableProps, flagFn } = useTable({
    columns,
    API: relationUserList,
  });
  const formData = [

  ];
  return (
    <>
      <HeaderTitle />
      <FormList
        formData={formData}
        changeQuery={changeQuery}
        extraRender={
          <ExportData
            title="订单列表"
            API={relationUserList}
            query={query}
            // dataParse={excelDataParse}
            extend={{
              level: levelObj,
              'Merchant.shopLevel': levelObjs,
              allIncome: 'amount',
              balance: 'amount',
              frozenAmount: 'amount',
              subscriptionAmount: 'amount',
              relationUserAmount: 'amount',
            }}
            columns={{
              id: '订单编号',
              nickname: '用户名称',
              'phone': '联系方式',
              'level': '用户身份',
              'Merchant.id': '店铺编号',
              'Merchant.title': '店铺名称',
              'Merchant.shopLevel': '店铺身份',
              allIncome: '总收益',
              balance: '账户余额',
              frozenAmount: '冻结金额',
              subscriptionAmount: '总认购额',
              relationUserAmount: '竞拍差价统计',
            }}
          />
        }
      />
      <Table {...tableProps} />
    </>
  );
}

export default FinanceProfit;
